import facebookIcon from '../assets/facebookLogo.svg';
import linkedinIcon from '../assets/linkedinIcon (2).svg';
import instagramIcon from '../assets/instagramLogo.svg';
import twitterIcon from '../assets/twitterIcon (2).svg';
import productHuntIcon from '../assets/producthuntLogo.svg';
import mediumIcon from '../assets/mediumLogo.svg';
import { Link } from "react-router-dom";
import { useLanguage } from '../config/language/LanguageContext';
import appleLogo from '../assets/appleLogo.svg';
import googleLogo from '../assets/googlePlayLogo.svg';

export default function FooterCTA() {
  const { locale } = useLanguage();

  return (
    <section className="bg-gray-900 text-white py-16">
      <div className="max-w-6xl mx-auto flex flex-col items-center justify-center text-center px-4 md:px-0">
        <h2 className="text-3xl md:text-4xl font-semibold leading-tight">
          {locale.FOOTER.footerHeading}
        </h2>

        <div className="flex gap-4 flex-col sm:flex-row justify-center items-center mt-6">
          <a
            href="https://apps.apple.com/ng/app/myqrmenu/id6745400220"
            className="flex items-center gap-3 px-3 py-2 border border-white rounded-lg bg-black text-white hover:scale-105 transition-transform"
          >
            <img
              src={appleLogo}
              alt="Phone Mockup"
              className="w-8 h-8"
            />
            <div>
              <p className="text-xs opacity-80 leading-none">
                Download on the
              </p>
              <p className="text-xl font-semibold leading-none">
                App Store
              </p>
            </div>
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.dastech.myqrmenu&pcampaignid=web_share"
            className="flex items-center gap-3 px-3 py-2 border border-white rounded-lg bg-black text-white hover:scale-105 transition-transform"
          >
            <div>
              <img
                src={googleLogo}
                alt="Phone Mockup"
                className="w-8 h-8"
              />
            </div>
            <div>
              <p className="text-xs opacity-80 leading-none">GET IT ON</p>
              <p className="text-xl font-semibold leading-none">
                Google Play
              </p>
            </div>
          </a>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center gap-4">
          <p className="text-white text-[21px]">{locale.FOOTER.footerConnect}</p>
          <div className="flex flex-row gap-4">
            <a href="https://www.facebook.com/share/1Z7nz5uFmK/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
              <img src={facebookIcon} alt="Facebook" className="cursor-pointer" />
            </a>
            <a href="https://www.linkedin.com/company/my-qrmenu/" target="_blank" rel="noopener noreferrer">
              <img src={linkedinIcon} alt="LinkedIn" className="cursor-pointer" />
            </a>
            <a href="https://www.instagram.com/getmyqrmenu/" target="_blank" rel="noopener noreferrer">
              <img src={instagramIcon} alt="Instagram" className="cursor-pointer" />
            </a>
            <a href="https://x.com/getmyqrmenu" target="_blank" rel="noopener noreferrer">
              <img src={twitterIcon} alt="Twitter" className="cursor-pointer" />
            </a>
            <a
              href="https://www.producthunt.com/posts/myqrmenu?utm_source=other&utm_medium=social"
              target="_blank"
              rel="noopener noreferrer">
              <img src={productHuntIcon} alt="Product Hunt" className="cursor-pointer" />
            </a>
            <a
              href="https://medium.com/myqrmenu"
              target="_blank"
              rel="noopener noreferrer">
              <img src={mediumIcon} alt="Medium" className="cursor-pointer" />
            </a>
          </div>
        </div>

        <div className="mt-12 w-full flex justify-between items-center text-gray-400 text-sm">
          <label className="hover:text-white transition">
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="/terms-and-conditions"
              className="text-orange-500 underline hover:text-orange-600"
            >
              {locale.FOOTER.footerTerms}
            </Link>
          </label>

          <label className="hover:text-white transition">
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="/help-center"
              className="text-orange-500 underline hover:text-orange-600"
            >
              {locale.FOOTER.footerHelp}
            </Link>
          </label>

          <label className="hover:text-white transition">
            <Link
              target="_blank"
              rel="noopener noreferrer"
              to="/privacy-policy"
              className="text-orange-500 underline hover:text-orange-600"
            >
              {locale.FOOTER.footerPrivacy}
            </Link>
          </label>
        </div>
        <span className="mt-8 block text-gray-400 text-base">{locale.FOOTER.footerCopyright}</span>
      </div>
    </section>
  );
}
